<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="11" lg="10">
        <v-card flat>
          <v-card-text>
            Formulario
          </v-card-text>
          <v-card-text>
            <v-card
              flat
              v-for="(item, index) in listForm"
              :key="index"
              class="my-1"
            >
              <v-alert outlined dense color="green">
                <v-row>
                  <v-col class="grow pt-8">
                    <label :for="item.name" class="text--secondary">
                      {{ item.label }}:
                    </label>
                  </v-col>
                  <v-col class="grow">
                    <div
                      v-if="['select'].includes(item.inputType)"
                      class="col-7"
                    >
                      <!-- <select class="form-control form-control-sm">
                          <option
                            v-for="(option, index) in item.value"
                            :key="index"
                            >{{ option.name }}</option
                          >
                        </select> -->
                      <v-select
                        dense
                        outlined
                        :items="item.value"
                        item-text="name"
                        item-value="value"
                        :label="item.placeholder"
                        :hint="item.hint != '' ? item.hint : ''"
                        :hide-details="item.hint != '' ? false : true"
                      >
                      </v-select>
                    </div>
                    <div
                      v-else-if="['radio'].includes(item.inputType)"
                      class="col-7"
                    >
                      <v-radio-group dense readonly>
                        <v-radio
                          v-for="(option, index) of item.value"
                          :key="index"
                          :label="option.name"
                          :value="option.value"
                        ></v-radio>
                        <!-- <input
                              :type="item.inputType"
                              :id="'Option-' + index"
                              :name="item.name + '-options'"
                              class=" col-1 form-check-input"
                              disabled
                            /> -->
                      </v-radio-group>
                    </div>
                    <div
                      v-else-if="['checkbox'].includes(item.inputType)"
                      class="col-7"
                    >
                      <v-checkbox
                        v-model="checkbox"
                        :label="`Checkbox 1: ${checkbox.toString()}`"
                      ></v-checkbox>
                      <v-radio
                        v-for="(option, index) of item.value"
                        :key="index"
                        :label="option.name"
                        :value="option.value"
                      ></v-radio>
                      <!-- <input
                              :type="item.inputType"
                              :id="'Option-' + index"
                              :name="item.name + '-options'"
                              class=" col-1 form-check-input"
                              disabled
                            /> -->
                    </div>
                    <div v-else class="col-7 text-left">
                      <v-text-field
                        dense
                        readonly
                        outlined
                        full-width
                        persistent-hint
                        :type="item.inputType"
                        :label="item.placeholder"
                        :hint="item.hint != '' ? item.hint : ''"
                        :hide-details="item.hint != '' ? false : true"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <!-- <v-col class="shrink">
                    <v-card-actions>
                      <v-row align="center" justify="end">
                        <v-btn icon>
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="removeItem(index)">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-row>
                    </v-card-actions>
                  </v-col> -->
                </v-row>
              </v-alert>

              <!-- <v-card-text
                  class="border border-info rounded d-flex flex-row form-group bg-white"
                >
                  <div
                    class="col-1 d-flex flex-row p-0 justify-content-around align-items-start pt-1"
                  >
                    <a
                      :href="'#' + item.name + '-panel'"
                      data-toggle="collapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="#collapseOne"
                      title="Editar"
                    >
                      <i class="fas fa-pen fa-1x pin-btn"></i>
                    </a>
                  </div>
                </v-card-text> -->
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  created() {
    this.getSurvey();
  },

  data() {
    return {
      isLoading: false,
      listItems: [
        {
          icon: "mdi-alphabetical-variant",
          type: "input",
          inputType: "text",
          label: "Campo de Texto",
          placeholder: "",
        },
        {
          icon: "mdi-at",
          type: "input",
          inputType: "email",
          label: "Correo",
          placeholder: "username@example.com",
        },
        {
          icon: "mdi-pound",
          type: "input",
          inputType: "number",
          label: "Número",
          placeholder: "123",
        },
        // {
        //   icon: "mdi-calendar-range",
        //   type: "input",
        //   inputType: "date",
        //   label: "Campo de Fecha",
        // },
        {
          icon: "mdi-format-list-checkbox",
          type: "checklist",
          inputType: "checkbox",
          label: "Selección Multiple",
          placeholder: "",
          value: [
            {
              name: "Option 1",
              value: "option-1",
            },
            {
              name: "Option 2",
              value: "option-2",
            },
            {
              name: "Option 3",
              value: "option-3",
            },
          ],
        },
        {
          icon: "mdi-order-bool-ascending",
          type: "radios",
          inputType: "radio",
          label: "Radio group",
          placeholder: "",
          value: [
            {
              name: "Option 1",
              value: "option-1",
            },
            {
              name: "Option 2",
              value: "option-2",
            },
          ],
        },
        {
          icon: "mdi-list-box",
          type: "select",
          inputType: "select",
          label: "Lista",
          placeholder: "",
          value: [
            {
              name: "Option 1",
              value: "option-1",
            },
            {
              name: "Option 2",
              value: "option-2",
            },
            {
              name: "Option 3",
              value: "option-3",
            },
          ],
        },
      ],
      listForm: [],
      icons: {
        text: "fas fa-font",
        email: "fas fa-at",
        number: "fas fa-hashtag",
        date: "far fa-calendar-check",
        checkbox: "far fa-check-square",
        "checkbox-group": "fas fas-check-square",
        radio: "far fa-check-circle",
        select: "fas fa-bars",
      },
    };
  },

  methods: {
    async getSurvey() {
      this.isLoading = true;

      const payload = this.$route.params.SurveyId;

      await PbxHttpClient.get(`/surveys/survey/${payload}`)
        .then((res) => {
          this.listForm = res.data.question;

          this.listForm.forEach((item) => {
            if (["radio", "select", "checkbox"].includes(item.inputType)) {
              item.value = JSON.parse(item.value);
            }
          });
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async submitForm() {
      this.isLoading = true;

      try {
        this.listForm.forEach(
          (question) => (question.survey_id = this.$route.params.SurveyId)
        );

        const payload = { data: this.listForm };

        const { data } = await PbxHttpClient.post("/surveys/question", payload);

        this.$snotify.success(`Preguntas creadas con éxito.`);

        this.$router.push({ name: "Crear Encuesta" });
      } catch (err) {
        this.$snotify.error(err.response?.data?.error, "¡Error!");
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
